var _rect, _path, _path2, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 89,
    viewBox: "0 0 562 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 87.3519,
    rx: 4,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79087 1.80515 0 4.01429 0V87.3519C1.80515 87.3519 0 85.561 0 83.3519V4Z",
    fill: "#E9ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M519.85 0H558C560.209 0 562 1.79086 562 4V85C562 87.2091 560.209 89 558 89H519.85V0Z",
    fill: "#F8F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 24.7222,
    width: 330.175,
    height: 13.1852,
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 51.0925,
    width: 76.2714,
    height: 13.1852,
    fill: "#E9ECEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCard);
export default __webpack_public_path__ + "static/media/NoCard.3dc1e358ba119e4550ea4999e8421aed.svg";
export { ForwardRef as ReactComponent };